/**
 * 식별자를 **짧게 «보이게»** 한다. 값을 바꾸지 않는다.
 *
 * 🔴 왜 필요한가(eric 확정 2026-09-22 · 방안 A): 목록의 첫 열이 36자 UUID 라
 *    **표의 주인공이 식별자**가 되어 있었다. 사람이 목록에서 찾는 것은 「무엇인가」지
 *    「무엇으로 부르는가」가 아니다. 이름을 앞세우고 ID 는 뒤로 물린다.
 *
 * ⚠ **자르는 것은 화면뿐이다.** 자른 값을 다시 서버로 보내지 마라 — 표시 전용 함수다.
 */
const SHORT_ID_LEN = 8

/**
 * 어느 쪽을 남기는가.
 * - `'head'` — 앞을 남기고 뒤를 줄인다(기본). UUID 처럼 **앞 마디가 서로 가르는** 값(작업 · 명령 ID · 행위자)
 * - `'tail'` — 뒤를 남기고 **앞을** 줄인다(`…095822-01`). 시료 번호처럼 **끝의 일련번호가 서로 가르는** 값
 *   (쵸단 실측 2026-09-30 — 앞 8자 꼴은 `TEST-202…` 만 남아 한 회차의 시료가 전부 같아 보였다)
 */
export type ShortIdKeep = 'head' | 'tail'

/** 앞 8자 + 말줄임. 8 은 UUID 첫 마디 길이다(`76954081-…`) — 그 마디면 서로 구분된다 */
export function shortId(
  id: string,
  len: number = SHORT_ID_LEN,
  keep: ShortIdKeep = 'head',
): string {
  if (id.length <= len) return id
  return keep === 'tail' ? `…${id.slice(id.length - len)}` : `${id.slice(0, len)}…`
}
